export default {
  loginData: {},
  findAccoutInfo: {}, //* ID/PW 찾기 정보
  views: {
    isLogin: false,
  },
};
